import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormSelect from '../../../components/form/FormSelect';

import { followUpUpdate } from '../../../store/slices/tenantSlices/dailyReportSlice';
import FormDateInput from '../../../components/form/FormDateInput';
import { parse } from 'date-fns';
import { useTimezone } from '../../../store/slices/commonSlice';
import { toZonedTime } from 'date-fns-tz';

const EditFollowUpModal = ({
  isOpen,
  onCloseClick,
  isEdit = false,
  editRecord = null,
  userOptions = []
}) => {
  const dispatch = useDispatch();
  const timezone = useTimezone();
  const today = toZonedTime(new Date(), timezone);

  const initialValues = {
    userId: '',
    date_and_time: ''
  };

  const validationSchema = Yup.object({
    userId: Yup.string().required('user is required'),
    date_and_time: Yup.string().required('date and time is required')
  });

  const onSubmit = async () => {
    try {
      const payload = { ...values, id: editRecord.id };
      const response = await dispatch(followUpUpdate(payload)).unwrap();
      if (response && response?.message) {
        toast.success('Record Updated Successfully');
        onCloseClick(true);
        resetForm();
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    setFieldValue,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setValues
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  useEffect(() => {
    setValues({
      ...values,
      userId: Number(editRecord?.userId) || '',
      date_and_time: parse(editRecord?.date_and_time, 'yyyy-MM-dd HH:mm:ss', today) || ''
    });
  }, [editRecord]);

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">Edit Follow Up</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="crms" onSubmit={handleSubmit}>
          <Row>
            <Col lg="4" md="4" className="flex-row">
              <FormDateInput
                name="date_and_time"
                dateFormat="yyyy-MM-dd HH:mm:ss"
                label="Date"
                showTimeSelect={true}
                minDate={new Date(editRecord?.date_and_time) || today}
                value={values.date_and_time}
                onChange={(e) => setFieldValue('date_and_time', e.target.value)}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="4" md="4" className="flex-row">
              <FormSelect
                label="User"
                placeholder="Select User"
                value={values.userId}
                onChange={handleChange}
                onBlur={handleBlur}
                name="userId"
                options={userOptions}
                touched={touched}
                errors={errors}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="crms" type="submit" className="px-5 bg-primary border-primary">
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

EditFollowUpModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any,
  userOptions: PropTypes.array
};

export default EditFollowUpModal;
